'use client';
import React, { useState, useEffect } from 'react';
import * as Styled from './styled';
import { Row } from '@/ui/primatives';
import { IUser } from '@/types';
import { IReferralStatus } from '@/lib/namespaceApi';
import useNamespaceCredits from '@/hooks/useNamespaceCredits';
import ReferralButton from '@/components/ReferralButton';
import useOxenSession from '@/hooks/useOxenSession';
import { Container } from '@/ui/PageLayout';
import { CountUp } from 'use-count-up';
import Button from '@/ui/Button';
// Format the price above to USD using the locale, style, and currency.
const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const AvailableCreditsBanner: React.FC<{
  currentUser?: IUser;
  availableCredits: number;
  hideBuyButton?: boolean;
  referralStatus?: IReferralStatus;
}> = ({ currentUser, availableCredits, hideBuyButton, referralStatus }) => {
  const [startCredits, setStartCredits] = useState(availableCredits);
  const [endCredits, setEndCredits] = useState(availableCredits);

  const showBuyButton = !hideBuyButton;

  useEffect(() => {
    if (availableCredits !== endCredits) {
      setStartCredits(endCredits);
      setEndCredits(availableCredits);
    }
  }, [availableCredits]);

  // console.log('availableCredits', typeof availableCredits);
  // console.log('startCredits', typeof startCredits);

  return (
    <Styled.AvailableCreditsBanner>
      <Container style={{ paddingTop: 0, paddingBottom: 0 }}>
        <Row gap={10} alignItems="center" justifyContent="space-between">
          <div>
            You have{' '}
            <b>
              <CountUp
                isCounting
                key={`${startCredits}-${endCredits}`}
                start={startCredits}
                end={endCredits}
                duration={3.2}
                formatter={(value) => USDollar.format(value)}
              />
            </b>{' '}
            credits remaining
          </div>
          <Row gap={10}>
            {currentUser && (
              <ReferralButton
                currentUser={currentUser}
                quiet
                canRefer={referralStatus?.can_refer}
                message={referralStatus?.message}
              />
            )}
            {showBuyButton && (
              <Button.Primary href="/billing/compute_credits" target="_blank" small>
                Buy More Credits
              </Button.Primary>
            )}
          </Row>
        </Row>
      </Container>
    </Styled.AvailableCreditsBanner>
  );
};

const AvailableCreditsBannerLoader: React.FC<{ hideBuyButton?: boolean; referralStatus?: IReferralStatus }> = ({
  hideBuyButton,
  referralStatus,
}) => {
  const { namespaceCredits } = useNamespaceCredits();
  const availableCredits = namespaceCredits?.available_credits;
  const { currentUser } = useOxenSession();

  return availableCredits ? (
    <AvailableCreditsBanner
      referralStatus={referralStatus}
      currentUser={currentUser}
      availableCredits={availableCredits}
      hideBuyButton={hideBuyButton}
    />
  ) : null;
};

export default AvailableCreditsBannerLoader;
